module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "download-target__graphs",
    attrs: {
      "id": "las-downloadable-region"
    }
  }, [_c('div', {
    attrs: {
      "id": "viewership-graph-pdf"
    }
  }, [_c('viewership-graph', {
    attrs: {
      "viewershipData": _vm.viewershipData,
      "networks": _vm.networks,
      "isGraphOnly": true
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "universe-graph-pdf"
    }
  }, [_c('universe-stability-graph', {
    attrs: {
      "data": _vm.universeData
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "age-market-breaker-graph-pdf"
    }
  }, [_c('age-market-breaker-graph', {
    attrs: {
      "data": _vm.ageMarketBreakerData,
      "meanAge": _vm.meanAge
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "age-graph-pdf"
    }
  }, [_c('age-graph', {
    attrs: {
      "data": _vm.ageData,
      "meanAge": _vm.meanAge
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "income-graph-pdf"
    }
  }, [_c('income-graph', {
    attrs: {
      "data": _vm.incomeData
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ee4e646"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/graphs/LASDownloadableGraphs.vue
// module id = 1890
// module chunks = 0